import {
  AfterViewInit,
  Component,
  ComponentRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewContainerRef,
  DestroyRef,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import themes from 'devextreme/ui/themes';
import { MatExpansionModule } from '@angular/material/expansion';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  DxButtonModule,
  DxCheckBoxModule,
  DxDataGridComponent,
  DxDataGridModule,
  DxFormModule,
  DxPopupModule,
  DxScrollViewModule,
  DxSwitchModule,
  DxTabsModule,
  DxToolbarModule,
  DxPopoverModule,
  DxTreeListModule, DxActionSheetModule, DxContextMenuModule, DxTreeListComponent
} from 'devextreme-angular';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import {ColumnModel, Format, SumListItem, SumModel} from '../../models/dx-data-table.model';
import { locale } from 'devextreme/localization';
import config from 'devextreme/core/config';
import {
  FormsFooterComponent,
  UserProcessData,
} from '../../layouts/main/forms-footer/forms-footer.component';
import { CURRENCY_FORMAT } from '../../constants/currency';
import { OrtakService } from '../../services/ortak.service';
import { PagerDisplayMode } from 'devextreme/common/grids';
import {ButtonStyle, ButtonType} from "devextreme/common";
import {ButtonWithIconObject} from "../../constants";
import {ScreenService} from "../../services/screen.service";
import jsPDF from "jspdf";
import {exportDataGrid as exportDataGridToPdf} from "devextreme/pdf_exporter";
import {DxTreeListTypes} from "devextreme-angular/ui/tree-list";
import {DlistDto, FormDto} from "../../models/ortak.dtos";
import { InitNewRowEvent } from 'devextreme/ui/tree_list';
import { CellTemplate } from '../../constants/cellTemplate';
import { EditCellTemplatePipe } from '../../pipes/edit-cell-template/edit-cell-template.pipe';
import { CellTemplatePipe } from '../../pipes/cell-template/cell-template.pipe';
import { confirm } from 'devextreme/ui/dialog';
import { SetDlist_Request } from '../../models/ortak.dtos';
import { UtilsService } from '../../services/utils.service';
import { AuthService } from '../../../../../../auth/src/lib/auth.service';
import { FormMetadataService } from '../../services/form-metadata.service';
import { DListService } from '../../../../../../ys/src/lib/components/DList/DList.service';
import { GenDlist } from '../../../../../../gen/src/lib/models/gen.models';
import { firstValueFrom, take } from 'rxjs';

export enum TreeListColumnTypes {
  genericColumn = 0,
  editButtonColumn = 1,
  deleteButtonColumn = 2,
  dateColumn = 3,
  bothDeleteEditButton = 4,
  detailButtonColumn = 5,
  currencyColumn = 6,
  previewButtonColumn = 7,
  addButtonColumn = 8,
  lookupColumn = 11,
  addDeleteEditButton = 12,
  ColumnWithButton = 15
}


@Component({
  selector: 'dk-dk-dx-tree-ctl-table',
  standalone: true,
  imports: [
    DxDataGridModule,
    DxToolbarModule,
    DxFormModule,
    DxButtonModule,
    DxCheckBoxModule,
    DxPopupModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    DxTabsModule,
    DxScrollViewModule,
    CommonModule,
    FormsFooterComponent,
    DxSwitchModule,
    DxPopoverModule,
    DxTreeListModule,
    DxActionSheetModule,
    DxContextMenuModule,
    CellTemplatePipe,
    EditCellTemplatePipe
  ],
  templateUrl: './dk-dx-tree-ctl-table.component.html',
  styleUrls: ['./dk-dx-tree-ctl-table.component.scss'],
})
export class DkDxTreeCtlTableComponent implements OnInit,OnChanges,AfterViewInit{
  private destroyRef = inject(DestroyRef);

  @ViewChild(DxTreeListComponent, { static: false }) treeList: DxTreeListComponent;
  @ViewChild('gridSettingsContainer', { read: ViewContainerRef }) gridSettingsContainer: ViewContainerRef;
  private gridSettingsComponentRef: ComponentRef<any>;
  gridSettingsPageVisible: boolean = false;
  selectedListRowWithName: GenDlist = new GenDlist();
  @Input() public dataSource!: any;
  @Input() public keyExpr!: string;
  @Input() public tableTittle!: string;
  @Input() public dListName!: string;
  @Input() public formMetaData!: FormDto;
  @Input() public donemAktif = true;
  @Input() public defaultValues: { [key: string]: any };
  @Input() public tableAddNewButton!: { newButtonText: string, disable?: boolean, icon?: string };
  @Input() otherActionBtnList: {
    name: string,
    icon: string,
    type?: ButtonType,
    stylingMode?: ButtonStyle,
    clickHandler?: any
  }[] = [];
  @Input() dynamicTableHeaderButtons!: any[];
  @Input() rightClickActions!: { text: string }[]
  @Input() inlineMenuActions!: ButtonWithIconObject[]
  @Input() public summaryVersion: string = 'total';
  @Input() public parentIdExpr!: string;
  @Input() public columnList!: ColumnModel[];
  @Input() public sumList!: SumModel[];
  @Input() public sumListItems!: SumListItem[];
  @Input() public columnTransactions = true;
  @Input() public gridCtlList!: DlistDto;
  @Input() public columnHidingEnabled = true;
  @Input() public isUserProcessFooter = true;
  @Input() public inlineCellEdit = false;
  @Input() public lookUpWithId = false;
  @Input() public showBorders = false;
  @Input() public height!:any;
  @Input() public heightAnimation!: string;
  @Input() public animationHeightStart!: string;
  @Input() public animationHeightEnd!: string;
  @Input() public style!: any;
  @Input() public width = '100%';
  @Input() public gridId!: string;
  @Input() public userProcessType = 'Tooltip';
  @Input() public noDataText = 'Veri yok.';
  @Input() public defaultSelectFirstItem = false;
  @Input() public sortByItem!: string;
  @Input() public showToolbar: boolean = true;
  @Input() public focusedRowIndex!: number;
  @Input() public sortDescending!: boolean;
  @Input() public baseTable = false;
  @Input() public rootValue!:any;
  @Input() public hasItemsExpr = 'hasItems';
  @Input() public remoteOperations = {filtering:true,grouping:true,sorting:true};
  @Input() public disableToolbarAddButton:boolean = false;
  @Input() public autoNavigateToFocusedRow:boolean = true;
  @Input() public cellTemplates: CellTemplate[];
  @Input() public editCellTemplates: CellTemplate[];
  @Input() public scrollToFocusedRowKey: number;
  @Input() public focusedRowKey!: any;
  @Input() public navigateRowKey!: any;
  @Input() gridLocked: boolean = false;

  @Output() public clickEditButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickDeleteButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickMenuButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickOtherBtn: EventEmitter<any> = new EventEmitter();
  @Output() public clickBothDeleteEditButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickPreviewButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickAddButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickAddCustomButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickColumnWithButtonButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickDetailButton: EventEmitter<any> = new EventEmitter();
  @Output() public selectedRowData: EventEmitter<any> = new EventEmitter();
  @Output() public rowDblClick: EventEmitter<any> = new EventEmitter();
  @Output() public focusedRowIndexNumber: EventEmitter<any> = new EventEmitter();
  @Output() public rightClicked: EventEmitter<any> = new EventEmitter();
  @Output() public focusedRowChanged: EventEmitter<any> = new EventEmitter();
  @Output() public onInitNewRow: EventEmitter<any> = new EventEmitter();
  @Output() dynamicTableHeaderButtonClicked = new EventEmitter<void>();

  sumResults: any[] = [];
  selectedRowsTotal = 0;
  lookupData:any;
  valueFormat: Format;
  gridListCtlNew: DlistDto;
  userProcessData: UserProcessData = new UserProcessData();
  public allowedPageSizes = [15, 25, 50, 100];
  public currencyFormat = CURRENCY_FORMAT;

  readonly displayModes = [
    { text: "Display Mode 'full'", value: 'full' },
    { text: "Display Mode 'compact'", value: 'compact' },
  ];
  actionSheetTarget: any = '';

  displayMode:PagerDisplayMode = 'full';
  crudShowFilter = false
  showPageSizeSelector = true;
  showInfo = true;
  showSumInfo: boolean;
  showNavButtons = true;
  columnChooserModes: any;
  searchEnabled: boolean;
  editorOptions: any;
  allowSelectAll: any;
  selectByClick: any;
  recursive: any;
  showFilterRow: boolean;
  showPaging: boolean;



  showColumnChooser: boolean;
  showGroup: boolean;
  allMode: string;
  checkBoxesMode: string;
  target: any;
  addRow: boolean = false;
  selectedRows: number[] = [];
  selectionChangedBySelectbox: boolean;
  actionSheetVisible = false
  private actionSheetRowData: any;

  customizeColumns(columns: any) {
    columns[0].width = 70;
  }
  public columnType = TreeListColumnTypes;
  treeGridIdRandom: any;
  clearFilterButtonOptions = {
    icon: 'clear',
    hint: 'Temizle',
    onClick: () => {
      this.clearHeaderFilter()
    },
  }
  refreshDataGridButtonOptions = {
    icon: 'refresh',
    hint: 'Yenile',
    onClick: () => {
      this.refreshTreeListGrid()
    },
  }

  public isAdmin = false;
  userListEditRole: string = '';
  public isListEditAdmin = false;

  gridStateSettingButton = {
    icon: 'rowproperties',
    hint: 'Liste Ayarları',
    stylingMode: 'contained',
    type: 'default',
    elementAttr: {},
    onClick: () => {
      this.handleGridSettingSaveBtn()
    }
  }
  gridStateSettingResetButton = {
    icon: 'clearsquare',
    hint: 'Liste Resetleme',
    stylingMode: 'contained',
    type: 'danger',
    elementAttr: {},
    onClick: () => {
      this.handleResetGridSettingSaveBtn()
    }
  }

  constructor(public ortakService:OrtakService,public screenService:ScreenService,
              private authService: AuthService, private utilsService: UtilsService,
              private dListService: DListService, private formMetadataService: FormMetadataService) {
    this.treeGridIdRandom = 'grid_' + Math.random().toString(36).substring(7);
    this.otherActionClicked.bind(this)
    locale('tr');
    config({ defaultCurrency: 'TRY' });
    this.allMode = 'page';
    this.checkBoxesMode = themes.current().startsWith('material')
      ? 'always'
      : 'always';
    this.showFilterRow = true;
    this.showSumInfo = false;
    this.showGroup = true;
    this.showColumnChooser = true;
    this.showPaging = true;
    this.searchEnabled = true;
    this.editorOptions = { placeholder: 'Ara' };
    this.allowSelectAll = true;
    this.selectByClick = true;
    this.recursive = true;
    this.columnChooserModes = [
      {
        key: 'dragAndDrop',
        name: 'Sürükle ve bırak',
      },
      {
        key: 'select',
        name: 'Seç',
      },
    ];
    const storageValue = localStorage.getItem('storage');
    if (storageValue) {
      const storageData = JSON.parse(storageValue);
      if (storageData && storageData.pageSize === 0) {
        storageData.pageSize = 10;
        localStorage.setItem('storage', JSON.stringify(storageData));
      }
    }
  }
  ngOnInit() {
    this.isAdmin = this.authService.isUserAdmin();
    this.gridSettingTypeButton();
  }

  gridSettingTypeButton(){
    const roleStatus = this.authService.isListRole();
    const isDaBAdmin = roleStatus.isDaBAdmin;
    const isListAdmin = roleStatus.isListAdmin;

    if (isDaBAdmin) {
      this.userListEditRole = 'DaBAdmin';
      this.isListEditAdmin = true;
      this.gridStateSettingButton.type = 'normal';
      this.gridStateSettingResetButton.type = 'normal';
      this.gridStateSettingResetButton.elementAttr= {class:'custom-orange-type'};
      this.gridStateSettingButton.elementAttr= {class:'custom-orange-type'};
      this.gridStateSettingButton.hint = 'DaBAdmin Ayarları';
    }
    else if (isListAdmin) {
      this.userListEditRole = 'ListAdmin';
      this.gridStateSettingButton.type = 'danger';
      this.gridStateSettingResetButton.type = 'danger';
      this.gridStateSettingButton.hint = 'ListAdmin Ayarları';
    }
    else {
      this.userListEditRole = '';
      this.gridStateSettingButton.type = 'normal';
      this.gridStateSettingResetButton.type = 'normal';
      this.gridStateSettingButton.hint = 'Kullanıcı Ayarları';
    }
  }

  handleGridSettingSaveBtn() {
    const state = this.getStateWithCaptions();

    confirm('Kaydetmek istiyor musunuz?', 'Liste Ayarları').then((res) => {
      if (res) {
        this.ortakService.SetDlist_Request(new SetDlist_Request({
          dListCode: this.gridCtlList?.dlistCode,
          dxColumns: state.columns,
          resetYn: false,
          rol: this.userListEditRole
        })).then((res) => {
          if (res.response.result === true) {
            this.utilsService.showSuccess('Liste ayarları başarıyla güncellendi.')
            this.gridCtlList.fields = res.response.dListMetadata.fields
          } else {
            this.utilsService.showError(res.response.errorMessage)
          }
        })
      }
    });
  }

  handleResetGridSettingSaveBtn() {
    const state = this.getStateWithCaptions();

    confirm('Liste ayarlarını sıfırlamak istiyor musunuz?', 'Liste Ayarları').then((res) => {
      if (res) {
        this.ortakService.SetDlist_Request(new SetDlist_Request({
          dListCode: this.gridCtlList?.dlistCode,
          dxColumns: state.columns,
          resetYn: true,
          rol: this.userListEditRole
        })).then((res) => {
          if (res.response.result === true) {
            this.utilsService.showSuccess('Liste ayarları başarıyla güncellendi.')
            this.gridCtlList = res.response.dListMetadata
          } else {
            this.utilsService.showError(res.response.errorMessage)
          }
        })
      }
    });
  }

  async openGridSettingsPopup(listName: string) {
    this.dListService.getDlist('GenDlists');
    this.dListService.getDlist('GenDlistColumns');

    const [formMetadataGridsSetting, res] = await Promise.all([
      firstValueFrom(this.formMetadataService.getFormMetaData('GenDlistForm').pipe(take(1))),
      this.ortakService.getViewDataWithFilter('GenDlist', 'Id', [['DlistCode', '=', listName]])
    ]);

    if (!res || res.length === 0) {
      console.warn(`List name "${listName}" için kayıt bulunamadı.`);
      return;
    }

    this.selectedListRowWithName = { ...res[0] };
    this.gridSettingsPageVisible = true;

    setTimeout(async () => {
      const { DlistEditComponent } = await import('@dabnet-kamu/ys/components/DList/dlist-edit/dlist-edit.component');

      if (!this.gridSettingsContainer) {
        console.error('gridSettingsContainer is undefined');
        return;
      }

      this.gridSettingsContainer.clear();
      this.gridSettingsComponentRef = this.gridSettingsContainer.createComponent(DlistEditComponent);

      this.gridSettingsComponentRef.instance.selectedRow = this.selectedListRowWithName;
      this.gridSettingsComponentRef.instance.state = 'Edit';
      this.gridSettingsComponentRef.instance.isOpened = this.gridSettingsPageVisible;
      this.gridSettingsComponentRef.instance.dListFormMetada = formMetadataGridsSetting;

      this.gridSettingsComponentRef.instance.closePopup.subscribe((event: any) => {
        this.closeGridSettingPopupAfter(event);
      });
    }, 0);
  }

  onGridSettingPopupHidden() {
    if (this.gridSettingsComponentRef) {
      this.gridSettingsComponentRef.destroy();
      this.gridSettingsComponentRef = null;
    }
    this.gridSettingsPageVisible = false;
  }

  closeGridSettingPopupAfter(event: any) {
    this.onGridSettingPopupHidden();
  }

  getStateWithCaptions(): any {
    const state = this.treeList?.instance.state();

    if (state.columns) {
      state.columns = state.columns
        .filter((col: any) => col.name !== 'buttons' || col.dataField !== 'İşlemler' || col.name !== 'İşlemler')
        .map((col: any) => {
          const caption = this.treeList.instance.columnOption(col.dataField)?.caption;
          return {
            ...col,
            caption: caption || col.caption || col.dataField
          };
        });
    }

    return state;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['animationHeightEnd']) {
      document.documentElement.style.setProperty('--start-height', this.animationHeightStart);
      document.documentElement.style.setProperty('--end-height', this.animationHeightEnd);
    }
    if (changes && changes['focusedRowIndex']) {
      this.focusedRowIndex = changes['focusedRowIndex'].currentValue;
    }
    if (changes && changes['userProcessType']) {
      this.userProcessData.tooltip = this.userProcessType;
    }

    if (changes && changes['scrollToFocusedRowKey']) {
      if (this.scrollToFocusedRowKey) {
        setTimeout(() => {
          this.treeList.instance.navigateToRow(this.focusedRowKey);
        }, 100);
      }

    }
    if (changes && changes['navigateRowKey']) {
      if (this.navigateRowKey) {
        setTimeout(() => {
          this.treeList?.instance.navigateToRow(this.navigateRowKey)
        }, 2000)
      }
    }
  }

  getLookupData(e: any) {
    const lookupData = this.ortakService.lookUpData?.find(({lookupAd}) => lookupAd === e)
    return lookupData?.data || null
  }

  ngAfterViewInit(): void {
      this.ortakService.lookUpData$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res=>{
        this.lookupData = res;
      })
    // DKM-5345 Cedric: eski hâli — addRow görünüm denetlendikten sonra aynı turda değişiyordu
    // (toolbar addRowButton [visible]) → geliştirme modunda NG0100.
    // if (this.gridCtlList.editMode === 'popup') {
    //   this.addRow = true;
    // } else if (this.gridCtlList.editMode === 'row') {
    //   this.addRow = true;
    // } else if (this.gridCtlList.editMode === 'cell') {
    //   this.addRow = true;
    // } else if (this.gridCtlList.editMode === 'form') {
    //   this.addRow = true;
    // } else {
    //   this.addRow = false;
    // }
    // Değer aynı anda ve aynı kuralla hesaplanır; yalnız atama mikro göreve ertelenir.
    const mod = this.gridCtlList.editMode;
    const addRowAcik = mod === 'popup' || mod === 'row' || mod === 'cell' || mod === 'form';
    Promise.resolve().then(() => {
      this.addRow = addRowAcik;
    });
  }

  handleTableHeaderDynamicButtonClick(dynamicButton: any) {
    this.dynamicTableHeaderButtonClicked.emit(dynamicButton);
  }
  // hasItemsExpr(item: any) {
  //   const itemContainer=[]
  //   itemContainer.push(item)
  //
  //   itemContainer.forEach(i => {
  //     return i.UstKod === item.Kod;
  //   });
  //
  //     return true
  // }

    // if (!this.dataSource || !this.initialLoadComplete) {
    //   return false;
    // }else return this.dataSource.some((dataItem:any) => dataItem.UstKod === item.Kod);


  getSelectedRow(e: any) {
    this.userProcessData = new UserProcessData({
      ...e.data,
      tooltip: this.userProcessType,
    });
    this.selectedRowData.emit(e);
  }

  getOnRowDblClick(e: any) {
    this.userProcessData = new UserProcessData({
      ...e.data,
      tooltip: this.userProcessType,
    });
    this.rowDblClick.emit(e);
  }

  refreshTreeListGrid() {
    this.treeList.instance.refresh();
  }

  public clickEditButtonFunc = (e: any) => {
    this.clickEditButton.emit(e);
  };

  public clickDeleteButtonFunc = (e: any) => {
    this.clickDeleteButton.emit(e);
  };

  public clickmenuButtonFunc = (e: any) => {
    this.actionSheetTarget = e.event.currentTarget;
    this.actionSheetVisible = true
    this.actionSheetRowData = e.row.data
  };

  public clickBothDeleteEditButtonFunc = (e: any) => {
    this.clickBothDeleteEditButton.emit(e);
  };

  public clickDetailButtonFunc = (e: any) => {
    this.clickDetailButton.emit(e);
  };

  public clickAddButtonFunc = (e: any) => {
    this.clickAddButton.emit(e);
  };


  calculateCustomSummary(options: any) {
    const item = this.sumListItems.find((el) => el.name === options.name);
    if (item) {
      let totalValue = 0;
      this.dataSource.forEach((row: any) => {
        totalValue += row[item.column];
      });

      if (item.valueFormat === 'currency') {
        options.totalValue = totalValue.toLocaleString('tr-TR', {
          style: 'currency',
          currency: 'TRY',
        });
      } else {
        options.totalValue = totalValue;
      }
    }
  }

  clearFilter() {
    this.treeList.instance.clearFilter();
    //this.calculateCustomSummary(this.sumListItems);
    // this.dataGrid.instance.clearFilter();
  }

  showToolbars(){
    if(this.showToolbar){
      this.showToolbar = false;
    }
    else{
      this.showToolbar = true;
    }

  }
  onExporting(e: any) {
    if (e.format === 'pdf') {
      const doc = new jsPDF();
      exportDataGridToPdf({
        jsPDFDocument: doc,
        component: e.component,
      }).then(() => {
        doc.save('grid.pdf');
      });
    } else {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Employees');

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'DataGrid.xlsx');
        });
      });
      e.cancel = true;
    }
  }

  closedPopover(){
    this.crudShowFilter = false
  }

  // DKM-5344 Clara: Liste ayarlarını kaydet / resetle düğmeleri araç çubuğundan Tercihler popup'ının altına taşındı.
  /** Tercihler popup'ındaki "Liste Ayarlarını Kaydet" açıklaması (role göre kaydın kimi etkilediği). */
  get listeAyarKaydetAciklama(): string {
    if (this.userListEditRole === 'DaBAdmin') return 'Kolon sırası, genişlik ve başlıklar tüm kurumlar için varsayılan olur (DaBAdmin).';
    if (this.userListEditRole === 'ListAdmin') return 'Kolon sırası, genişlik ve başlıklar bu kurumdaki tüm kullanıcılar için kaydedilir (ListAdmin).';
    return 'Kolon sırası, genişlik ve başlıklar yalnız sizin için kaydedilir.';
  }

  /** Tercihler popup'ındaki "Liste Ayarlarını Resetle" açıklaması. */
  get listeAyarResetAciklama(): string {
    if (this.userListEditRole === 'ListAdmin') return 'Bu kurum için kaydedilmiş liste ayarları silinir, varsayılan düzene dönülür (ListAdmin).';
    return 'Kaydettiğiniz kişisel liste ayarları silinir, varsayılan düzene dönülür.';
  }

  tercihListeAyarKaydet() {
    this.closedPopover();
    this.handleGridSettingSaveBtn();
  }

  tercihListeAyarResetle() {
    this.closedPopover();
    this.handleResetGridSettingSaveBtn();
  }
  showSelectModule(){
    this.crudShowFilter = true;
  };

  eventHandler(event: any) {
    this.gridListCtlNew = this.gridCtlList;
    this.target = event;
    this.crudShowFilter = true

  }

  focusedRowIndexChange($event: number) {
    this.focusedRowIndexNumber.emit($event)
  }

  onInitNewRowFunc(e: InitNewRowEvent) {
    if(this.defaultValues){
    Object.keys(this.defaultValues).forEach(key => {
      e.data[key] = this.defaultValues[key];
    });
  }
    this.onInitNewRow.emit(e);
  }

  otherActionClicked = (button: any, data: any) => {
    this.clickOtherBtn.emit({
      button,
      rowData: data.row.data,
      buttonPosition: data.event.currentTarget,
      target: data.element.attributes.id.nodeValue,
      row: data.row
    })
  }

  contextMenu($event: any) {
    this.rightClicked.emit($event)
  }

  contextMenuRightClick(e: any) {
    this.selectedRowData.emit(e.row);
  }

  clickMenuButtonActions($event: any) {
    this.clickMenuButton.emit({button: $event.itemData, rowData: this.actionSheetRowData})
  }
  async selectionChangedHandler(e: DxTreeListTypes.SelectionChangedEvent) {
    await e.component.refresh(true)
    this.selectedRowData.emit(e)
    this.selectionChangedBySelectbox = false;
  }


  clearHeaderFilter() {
    this.treeList.instance.clearFilter('row');
    // this.dataGrid.instance.state(null)
  }


  logSelectedFilter($event: any) {



  }

  public onFocusedRowChangedFunc = (e: any) => {
    this.focusedRowChanged.emit(e);
  }
}
